import { Group, Tooltip } from "@mantine/core";
import {
  IconDeviceDesktop,
  IconDeviceMobile,
  IconDeviceTablet,
} from "@tabler/icons-react";
import { UAParser } from "ua-parser-js";

export function GetUserAgentString() {
  const userAgent = window.navigator.userAgent;
  const { browser, device } = UAParser(userAgent);
  return `${browser.name} / ${device.model} ${device.vendor}`;
}

export default function UserAgentDetails({ userAgent }) {
  const { browser, device } = UAParser(userAgent);
  let icon = <IconDeviceDesktop size={16} />;
  switch (device.type) {
    case "tablet":
      icon = <IconDeviceTablet size={16} />;
      break;
    case "mobile":
      icon = <IconDeviceMobile size={16} />;
      break;
  }
  return (
    <Tooltip label={userAgent}>
      <Group>
        {icon}
        {browser.name} / {device.model} {device.vendor}
      </Group>
    </Tooltip>
  );
}
